module.exports = "/static/assets/66f260aa0f03d5aed3f843a05968d33d.svg";